import { render } from "./QuoteAdditionalInsuanceQuestions.vue?vue&type=template&id=180bb9d6&scoped=true"
import script from "./QuoteAdditionalInsuanceQuestions.vue?vue&type=script&lang=js"
export * from "./QuoteAdditionalInsuanceQuestions.vue?vue&type=script&lang=js"

import "./QuoteAdditionalInsuanceQuestions.vue?vue&type=style&index=0&id=180bb9d6&lang=css"
import "./QuoteAdditionalInsuanceQuestions.vue?vue&type=style&index=1&id=180bb9d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180bb9d6"]])

export default __exports__